import type { CountryCode } from 'libphonenumber-js'
import { useCallback, useMemo } from 'react'
import payload from '../assets/data/countries.json' assert { type: 'json' }
import type { Country } from '../types'

export interface CountryOption {
	value: string
	label?: string
	callingCode?: string
}

interface UseCountry {
	countries: Country[]
	getCountryByCode: (_code: CountryCode) => Country | undefined
}

export const useCountry = (): UseCountry => {
	const countries = useMemo(() => payload as Country[], [])

	const getCountryByCode = useCallback(
		(code: CountryCode): Country | undefined => {
			return countries.find((country) => country.countryCode === code)
		},
		[countries]
	)

	return {
		countries,
		getCountryByCode,
	}
}
